import React from 'react';
import env from '../config/env';
import { useSettings } from '../context/SettingsContext';
import {
  Info,
  Pencil,
  Boxes,
  Trash2
} from 'lucide-react';

const ProductCard = ({ produkt, onDetaje, onEdito, onStok, onDelete }) => {
  const { getCurrencyCode } = useSettings();
  const currencyCode = getCurrencyCode();
  const { emri, kodi, cmimi_shitjes, zbritje_perqindje, eshte_aktiv, foto } = produkt;

  const imageUrl = foto?.[0]?.file_path
    ? `${env.API_URL_Image}/storage/${foto[0].file_path}`
    : 'https://dummyimage.com/300x375/cccccc/000000&text=Pa+Foto';

  return (
    <div className="card-premium-hover flex flex-col w-full overflow-hidden group animate-fade-in">
      {/* Fotoja e produktit */}
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-gray-100 dark:bg-dark-800">
        <img
          src={imageUrl}
          alt={emri}
          className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500 ease-out"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://dummyimage.com/300x375/cccccc/000000&text=Pa+Foto';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        {zbritje_perqindje > 0 && (
          <span className="absolute top-3 right-3 bg-gradient-primary text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-premium dark:shadow-glow-yellow-dark animate-scale-in">
            -{zbritje_perqindje}%
          </span>
        )}
        <span className={`absolute top-3 left-3 badge-premium ${
          parseInt(eshte_aktiv) === 1
            ? 'bg-green-500 dark:bg-green-600 text-white'
            : 'bg-red-500 dark:bg-red-600 text-white'
        }`}>
          {parseInt(eshte_aktiv) === 1 ? 'Aktiv' : 'Joaktiv'}
        </span>
      </div>

      {/* Informacionet */}
      <div className="p-5 space-y-3 flex flex-col flex-grow justify-between bg-white dark:bg-dark-800">
        <div className="space-y-2">
          <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100 line-clamp-2 capitalize group-hover:text-primary-600 dark:group-hover:text-primary-400 transition-colors">
            {emri}
          </h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 font-medium">
            Kodi: <span className="text-gray-700 dark:text-gray-300 font-semibold">{kodi}</span>
          </p>
          <div className="flex items-baseline gap-2">
            <p className="text-2xl font-bold text-gradient-logo">
              {cmimi_shitjes}
            </p>
            <span className="text-sm text-gray-500 dark:text-gray-400 font-medium">{currencyCode}</span>
          </div>
        </div>

        {/* Butonat */}
        <div className="grid grid-cols-2 gap-2 mt-4 pt-4 border-t border-gray-100 dark:border-dark-700">
          <button
            onClick={() => onDetaje(produkt)}
            className="flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2.5 rounded-xl 
              bg-gray-100 dark:bg-dark-700 text-gray-700 dark:text-gray-300 
              hover:bg-gray-200 dark:hover:bg-dark-600 hover:scale-105 transition-all duration-200 shadow-sm"
          >
            <Info size={16} /> Detaje
          </button>
          <button
            onClick={() => onEdito(produkt)}
            className="flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2.5 rounded-xl 
              bg-secondary-100 dark:bg-secondary-900/30 text-secondary-700 dark:text-secondary-300 
              hover:bg-secondary-200 dark:hover:bg-secondary-900/50 hover:scale-105 transition-all duration-200 shadow-sm"
          >
            <Pencil size={16} /> Edito
          </button>
          <button
            onClick={() => onStok(produkt)}
            className="flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2.5 rounded-xl 
              bg-primary-100 dark:bg-primary-900/30 text-primary-700 dark:text-primary-300 
              hover:bg-primary-200 dark:hover:bg-primary-900/50 hover:scale-105 transition-all duration-200 shadow-sm"
          >
            <Boxes size={16} /> Stok
          </button>
          <button
            type="button"
            onClick={() => onDelete(produkt)}
            className="flex items-center justify-center gap-1.5 text-sm font-semibold px-3 py-2.5 rounded-xl 
              bg-gradient-to-r from-red-500 to-red-600 text-white 
              hover:from-red-600 hover:to-red-700 hover:scale-105 transition-all duration-200 shadow-md"
          >
            <Trash2 size={16} /> Fshi
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
